import { useState } from 'react'
import {
    Tabs,
    Tab,
    AllIc,
    ListTitle,
    LikeIc,
    ViewMore
} from '../meElements'
import {
    UserCommentList,
    CommentItem,
    NewsTitle,
    CommentDesc,
    CommentIc,
    CommentDescBody,
    CommentText,
    CommentDescBodyBottom,
    LikeButton,
    CommentLikeIc,
    Replies,
    CommentAt,
    EmtyComment
} from './userCommentsElements'
import { useSelector, useDispatch } from 'react-redux'
import { getUserComments, loadMoreComments } from '../../../store/reducer/userSlice'
import moment from 'moment'
import Loading from '../../../components/loading'

const UserComments = () => {
    const [all, setAll] = useState(true)
    const { comments: { data, totalRows } } = useSelector(state => state.user)
    const [_page, set_Page] = useState(1)
    const dispatch = useDispatch()
    const [loading, setLoading] = useState(false)
    const [sorting, setSorting] = useState(false)

    const handleChangeTab = value => {
        setAll(value)
        const params = value ? { _page: 1 } : { _page: 1, _sort: 'likeCount:desc' }
        
        setLoading(true)
        ;(async () => await dispatch(getUserComments(params)))()
        setLoading(false)
        setSorting(value)
        set_Page(1)
    }

    const handleViewMore = async () => {
        const params = sorting ? { _page: _page + 1, _sort: 'likeCount:desc' }:{ _page: _page + 1 }
        ;(async () => {
            setLoading(true)
            await dispatch(loadMoreComments(params))
            setLoading(false)
            set_Page(_page + 1)
        })()
    }

    

    return (
        <>
            {loading && <Loading />}
            <Tabs>
                <Tab onClick={() => handleChangeTab(true)} className={all && 'active'}><AllIc /> Tất cả</Tab>
                <Tab onClick={() => handleChangeTab(false)} className={!all && 'active'}><LikeIc /> Quan tâm nhất</Tab>
            </Tabs>
            <ListTitle>Bình luận</ListTitle>
            <UserCommentList>
                {!data || data?.length === 0 ? 
                <EmtyComment>Bạn chưa có bình luận nào.</EmtyComment>:
                data?.map((cmt, index) => (
                    <CommentItem key={index}>
                        <NewsTitle title={cmt.news.title} to={`/news/${cmt.news._id}`}>{cmt.news.title}</NewsTitle>
                        <CommentDesc>
                            <CommentIc />
                            <CommentDescBody>
                                <CommentText>{cmt.text}</CommentText>
                                <CommentDescBodyBottom>
                                    <LikeButton><CommentLikeIc /> {cmt.likes.length}</LikeButton>
                                    <Replies>{cmt.replies} trả lời</Replies>
                                    <CommentAt>Ngày {moment(cmt.createdAt).format('DD/MM/yyyy')}</CommentAt>
                                </CommentDescBodyBottom>
                            </CommentDescBody>
                        </CommentDesc>
                    </CommentItem>
                ))}
            </UserCommentList>
            {totalRows?.total > 8 && data?.length < totalRows?.total && <ViewMore onClick={handleViewMore} >{loading ? 'Đang load...':'Xem thêm bình luận'}</ViewMore>}
        </>
    )
}

export default UserComments
